import { API } from "aws-amplify";

/**
 * Query SlugPeople by an array of person_ids
 * @param {Array<string>} personIds - Array of person_id values to query
 * @returns {Promise<Array>} Array of person objects
 */
export async function getPersonsByIds(personIds) {
  if (!personIds || personIds.length === 0) {
    return [];
  }


  // Build the filter for multiple person_ids using OR logic
  const filters = personIds.map(id => `{person_id: {eq: "${id}"}}`).join(", ");
  const filterString = `filter: {or: [${filters}]}`;

  const query = `
    query GetPersonsByIds {
      listSlugPeople(
        limit: 10000,
        ${filterString}
      ) {
        items {
          dataset
          first_name
          last_name
          person_id
          external_id
          gender
          party
          eyecolor
          agegroup
          height
          build
          haircolor
          hairstyle
          facialhair
          skintone
          glasses
          dress
          persontype
          image
          uri
          constituency
          searchstring
        }
      }
    }
  `;

  try {
    const response = await API.graphql({
      query,
      authMode: 'API_KEY'  // Force API_KEY auth (AppSync schema requires it)
    });

    const items = response.data.listSlugPeople.items || [];
    return items;
  } catch (error) {
    console.error("Error querying persons by IDs:", error);
    if (error.errors) {
      console.error("GraphQL errors:", JSON.stringify(error.errors, null, 2));
    }
    throw error;
  }
}
